import Close from '@assets/close';
import Modal from '@components/Modal/Modal';
import {
  EMAIL_REMINDER_TEXT,
  EMAIL_REMINDER_TITLE_DEFAULT,
  EMAIL_REMINDER_TITLE_USERNAME,
  I18N_PROFILE_CONTEXT,
} from '@features/profile/ProfileForm.constants';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { BoldText, BottomSection, CloseIcon, Header, LightBg, SentEmailIcon, Text, TopSection } from './NotifyMeModal.styles';
import { NotifyMeModalProps } from './NotifyMeModal.types';

export const NotifyMeModal = ({ name, email, display, onClose }: NotifyMeModalProps): JSX.Element => {
  const { t } = useTranslation(I18N_PROFILE_CONTEXT);

  return (
    <Modal width={422} toDisplay={display}>
      <CloseIcon onClick={onClose}>
        <Close />
      </CloseIcon>
      <TopSection>
        <LightBg />
        <SentEmailIcon />
      </TopSection>
      <BottomSection>
        <Header>{name ? t(EMAIL_REMINDER_TITLE_USERNAME, { userName: name }) : t(EMAIL_REMINDER_TITLE_DEFAULT)}</Header>
        <Text>
          <Trans i18nKey={t(EMAIL_REMINDER_TEXT, { email })} components={[<BoldText key='1' />]} />
        </Text>
      </BottomSection>
    </Modal>
  );
};

export default NotifyMeModal;
